module.exports = __webpack_public_path__ + "static/media/tool4-desktop-es.a80430e8.png";